import React from "react";
import { useRouteMatch } from "react-router-dom";

import { AnalyticsBlocks } from "components/analytics";


const AnalyticsProductsPage = ({ standId }) => {

    const pathBase = "/showroom-configurator/analytics/";

    let match = useRouteMatch(`${pathBase}products/:pageNum`)

    return(
        <div className="analytics-visitors">
            <AnalyticsBlocks.ProductsDetailed
                standId={ standId }
                currentPage={ match ? parseInt(match.params.pageNum) : 1  }
                pathBase={ pathBase }
            />
        </div>
    );
}


export default AnalyticsProductsPage;